<script setup lang="ts">
import { CellState } from '../index'

withDefaults(
  defineProps<{
    label?: string | number
    state?: typeof CellState.Default | typeof CellState.Selected | typeof CellState.Disabled
    loading?: boolean
  }>(),
  {
    label: '',
    state: CellState.Default,
  },
)
</script>

<template lang="pug">
button.calendar-time.typ-14-20-500.flex-center-center.h-44.w-100p.br-10.cursor-pointer(
  type="button"
  :aria-pressed="state === CellState.Selected"
  :aria-busy="loading"
  :class="{ 'selected': state === CellState.Selected, 'calendar-loading': loading }"
  :disabled="loading || state === CellState.Disabled"
) {{ label }}
</template>

<style scoped src="../../calendar-loading.css"></style>

<style scoped>
.calendar-time {
  background: var(--cue-bg-neutral-none);
  color: var(--cue-content-neutral-secondary);
  border: 1px solid var(--cue-border-neutral-secondary);
  outline: none;

  &:not(:disabled):hover {
    background: var(--cue-bg-neutral-primary-hover);
  }

  &:not(:disabled):active {
    background: var(--cue-bg-neutral-primary-pressed);
  }

  &.selected {
    border: 2px solid var(--cue-border-primary-default);
    background: var(--cue-bg-primary-soft-dark);
    color: var(--cue-content-primary-on-soft);

    &:not(:disabled):hover {
      background: var(--cue-bg-primary-soft-dark-hover);
    }

    &:not(:disabled):active {
      background: var(--cue-bg-primary-soft-dark-pressed);
    }
  }

  &:disabled {
    --uno: cursor-not-allowed;
    border: 1px solid var(--cue-border-neutral-disabled);
    color: var(--cue-content-neutral-disabled);
    background: var(--cue-bg-neutral-disabled);
  }
}
</style>
